import { render, staticRenderFns } from "./table-input.vue?vue&type=template&id=5fa54ffc"
import script from "./table-input.vue?vue&type=script&lang=js"
export * from "./table-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa54ffc')) {
      api.createRecord('5fa54ffc', component.options)
    } else {
      api.reload('5fa54ffc', component.options)
    }
    module.hot.accept("./table-input.vue?vue&type=template&id=5fa54ffc", function () {
      api.rerender('5fa54ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/brand/table-input.vue"
export default component.exports